import {JobsiteCategory} from "@/graphql/kapitelTypes"
import {KapitelIcon} from "@/helper/icon";

export const sortedJobsiteCategories = [
    JobsiteCategory.Favorite,
    JobsiteCategory.Alternative,
    JobsiteCategory.Booked,
    JobsiteCategory.Other
]

export const getPrefixForJobsiteCategory = (jobsiteCategory: JobsiteCategory): string => {
    switch (jobsiteCategory) {
        case JobsiteCategory.Favorite: return'Lieblings'
        case JobsiteCategory.Alternative: return 'Alternativ'
        case JobsiteCategory.Booked: return 'Bekannte '
        // case JobsiteCategory.Blacklisted: return 'Gesperrte '
        case JobsiteCategory.Other: return 'Weitere '
    }
}

export const getLabelForJobsiteCategory = (jobsiteCategory: JobsiteCategory, plural = true): string => {
    const prefix = getPrefixForJobsiteCategory(jobsiteCategory)
    const jobsite = (prefix.substring(-1) === ' ') ? 'Station' : 'station'
    
    return prefix + jobsite + (plural ? 'en' : '')
}

export const getIconForJobsiteCategory = (jobsiteCategory: JobsiteCategory): string | null => {
    switch (jobsiteCategory) {
        case JobsiteCategory.Favorite: return KapitelIcon.favoriteJobsite
        case JobsiteCategory.Alternative: return KapitelIcon.alternativeJobsite
        case JobsiteCategory.Booked: return null
        case JobsiteCategory.Other: return null
    }
}

export enum SimplifiedJobsiteCategory {
    Favorite = 'FAVORITE',
    Additional = 'ADDITIONAL'
}
